import { render } from "./DisclaimerDialog.vue?vue&type=template&id=0fbde606&scoped=true"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=js"

import "./DisclaimerDialog.vue?vue&type=style&index=0&id=0fbde606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbde606"]])

export default __exports__